<template>
  <div class="chat-info">
    <div class="chat-info__avatar">
      <img v-if="head.avatar" :src="head.avatar" alt="" />
    </div>
    <div class="chat-info__title">
      {{ head.title }}
    </div>
    <div class="chat-info__stats">{{ headMembers }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { withUi } from '@/components/ui'

export default {
  components: {},
  mixins: [withUi],
  computed: {
    head() {
      return this.headActive
    },
    headMembers() {
      const mLength = this.head.members.length
      return `${mLength} ${this.$t('chat.info.members')}`
    },
    ...mapGetters('chat', ['headActive']),
  },
}
</script>

<style lang="scss" scoped>
.chat-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 46px 32px;
  border-bottom: 1px solid rgba(180, 187, 198, 0.13);
  &__avatar {
    position: relative;
    z-index: 1;
    overflow: hidden;
    width: 80px;
    height: 80px;
    background: #f4f4f4;
    border-radius: 10px;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &__title {
    margin-top: 22px;
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
  }
  &__stats {
    margin-top: 8px;
    font-size: 14px;
    line-height: 17px;
    color: $dark;
    text-align: center;
  }
}
</style>
